export default {
  SET_DASHBOARD_CMR: (state, payload) => {
    state.dashboardData = payload;
  },
  SET_DASHBOARD_CMR_TOTAL: (state, payload) => {
    state.dashboardCmrTotals = payload
  },
  SET_CMR: (state, payload) => {
    state.cmrData = payload;
  },
  SET_CMR_TOTAL: (state, payload) => {
    state.cmrTotals = payload
  },
  SET_PDF: (state, payload) => {
    state.pdf = payload
  },
 /* SET_PAGINATION: (state, payload) => {
    state.pagination = payload
  }*/
  SET_USERS: (state, payload) => {
    state.userData = payload;
  },
  SET_USERS_TOTAL: (state, payload) => {
    state.userTotals = payload
  },
  SET_ROLES: (state, payload) => {
    state.roles = payload
  },
  SET_ROLES_TOTAL: (state, payload) => {
    state.rolesTotals = payload
  },
  SET_ORGANIZATIONS: (state, payload) => {
    state.organizations = payload
  },
  SET_ORGANIZATIONS_TOTAL: (state, payload) => {
    state.organizationsTotals = payload
  },
  SET_COUNTRIES: (state, payload) => {
    state.countries = payload
  },
  SET_LOGIN_USER: (state, payload) => {
    state.loginUser = payload
  },
  SET_LANG: (state, payload) => {
    state.language = payload
  },
  SET_USER_ORGANIZATIONS: (state, payload) => {
    state.userOrganizations = payload
  }
}
